import { useEffect } from "react";

const ORIGIN = "https://idealrealestate.it";

/* Per-route SEO: updates the document head at render time (visible to
   crawlers that execute JS, including the deployed prerender). */
export default function Seo({ title, description, path = "/", noindex = false }) {
  useEffect(() => {
    document.title = title;
    const setMeta = (key, attr, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    const setLink = (rel, href) => {
      let el = document.head.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };
    setMeta("description", "name", description);
    setMeta("robots", "name", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1");
    setMeta("og:title", "property", title);
    setMeta("og:description", "property", description);
    setMeta("og:url", "property", `${ORIGIN}${path}`);
    setLink("canonical", `${ORIGIN}${path}`);
  }, [title, description, path, noindex]);

  return null;
}
